module.exports = __webpack_public_path__ + "img/luna llena.7e001740.svg";